import React from "react";
import { Container, Typography, Button, Box } from "@mui/material";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";

const NotFound = () => (
  <>
    <Helmet>
      <title>404 - Page Not Found | DeedMed</title>
      <meta name="robots" content="noindex" />
    </Helmet>
    <main>
      <Container maxWidth="sm" sx={{ py: 8 }}>
        <Box
          textAlign="center"
          sx={{ p: 4, bgcolor: "#f5f5f5", borderRadius: 3, boxShadow: 2 }}
        >
          <Typography variant="h2" color="primary" gutterBottom>
            404
          </Typography>
          <Typography variant="h5" gutterBottom>
            Page Not Found
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
            Sorry, the page you are looking for does not exist or has been
            moved.
          </Typography>
          <Button variant="contained" color="primary" component={Link} to="/">
            Go to Homepage
          </Button>
        </Box>
      </Container>
    </main>
  </>
);

export default NotFound;
